const empty=document.getElementById('empty');
const filterButtons=[...document.querySelectorAll('[data-filter]')];
const grids=[...document.querySelectorAll('.catalog-grid')];
const sectionHeadings=[...document.querySelectorAll('[data-section-heading]')];
let activeCategory='all';
function allCards(){return [...document.querySelectorAll('.product-card')];}
function update(){
  const cards=allCards();
  cards.forEach(c=>{
    const matchesCategory=activeCategory==='all'||c.dataset.category===activeCategory;
    c.hidden=!matchesCategory;
  });
  sectionHeadings.forEach(h=>{
    const cat=h.dataset.sectionHeading;
    const grid=document.getElementById(cat+'Grid');
    const hasVisible=grid&&[...grid.querySelectorAll('.product-card')].some(c=>!c.hidden);
    h.hidden=!hasVisible;
    if(grid) grid.hidden=!hasVisible;
  });
  empty.style.display=cards.some(c=>!c.hidden)?'none':'block';
}
filterButtons.forEach(btn=>btn.addEventListener('click',()=>{
  activeCategory=btn.dataset.filter;
  filterButtons.forEach(b=>b.classList.toggle('active',b===btn));
  update();
}));
update();

(() => {
  const targets = document.querySelectorAll('.catalog-hero, .footer-workbench');
  targets.forEach((target) => {
    let rect = target.getBoundingClientRect();
    let currentX = 0;
    let targetX = 0;
    let rafId = 0;
    const render = () => {
      currentX += (targetX - currentX) * 0.28;
      if (Math.abs(targetX - currentX) < 0.1) currentX = targetX;
      const width = Math.max(rect.width, 1);
      target.style.setProperty('--scan-x', `${currentX}px`);
      target.style.setProperty('--scan-ratio', String(currentX / width));
      rafId = Math.abs(targetX - currentX) >= 0.1 ? requestAnimationFrame(render) : 0;
    };
    const queue = () => { if (!rafId) rafId = requestAnimationFrame(render); };
    const move = (event) => {
      rect = target.getBoundingClientRect();
      targetX = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
      queue();
    };
    target.addEventListener('pointerenter', (event) => { target.classList.add('scan-active'); move(event); }, {passive:true});
    target.addEventListener('pointermove', move, {passive:true});
    target.addEventListener('pointerleave', () => { target.classList.remove('scan-active'); targetX = 0; queue(); }, {passive:true});
    window.addEventListener('resize', () => { rect = target.getBoundingClientRect(); currentX = Math.min(currentX, rect.width); targetX = Math.min(targetX, rect.width); queue(); }, {passive:true});
  });
})();